import React from "react";
import { connect } from "react-redux";

import gnpGeneral from "./../gnp-general.css";
//import gnpLogin from "./gnp-login.css";
import { callService, goTo } from "../tools";
import { servicios } from "./../properties";
import IngresaCorreo from "./ingresaCorreo.cmpt";
import IngresaContrasena from "./ingresaContrasena.cmpt";
import UsuarioBloqueado from "./usuarioBloqueado.cmpt";
import Preguntas from "./preguntas.cmpt";
import Contrato from "./contrato.cmpt";

const mapState = (state) => {
	return {
		loading: state.global.loading,
		accesoFamiliar: state.login.accesoFamiliar,
		paso: state.login.paso
	};
};

const mapDispatch = (dispatch) => {
	return {
		siguientePaso: (iPaso) => {
			dispatch({ "type": "LOGIN_PASO_SIGUIENTE", paso: iPaso});
		},
		limpiarRegistro: () => {
			dispatch({ "type": "LIMPIAR_REGISTRO" });
		},
		resetPaso: () => {
			dispatch({ "type": "LOGIN_RESET_PASO" }); 
		},
		alerta: (sTitulo, sMensaje, fnAccion) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnAccion});
		},
		resetAccesoFamiliar: () => {
			dispatch({ "type": "LOGIN_SET_ACCESO_FAMILIAR", "accesoFamiliar" : false }); 
		}
	};
};

class Flujo extends React.Component {
	
	siguiente = () => {
		this.props.siguientePaso(this.props.paso + 1);
	}
	
	componentWillMount = () => {
		this.props.resetPaso();
		this.props.limpiarRegistro();
		
		if(this.props.accesoFamiliar) {
			let $this = this;
			let llamaServicio = new callService({
				service: "accesoFamiliar.validaUsuario",
				data: { email: this.props.accesoFamiliar }
			}).execute().then((respuesta) => {
				console.log(respuesta);
				if(respuesta.valido == false) {
					$this.props.alerta("Importante", respuesta.message, () => {
						$this.props.resetAccesoFamiliar();
						goTo("login");
					});	
				}
			}).catch((error) => {
				$this.props.alerta("ERROR", error.message.mensaje);
			});	
		}
	}
	
	render() {
		return (
			<div className="gnp-generales loginGNP">
				<div className="content">
					{ this.props.paso == 0 && 
						<IngresaCorreo />
					}
					{ this.props.paso == 1 && 
						<IngresaContrasena />
					}
					{ this.props.paso == 2 && 
						<Preguntas />
					}
					{ this.props.paso == 3 && 
						<UsuarioBloqueado />
					}
					{ this.props.paso == 4 && 
						<Contrato />
					}
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/gnp-login/flujo.cmpt.js